import { Button, ButtonRow } from '@ksyos/design-system';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import type { IHsdqQuestion } from '../NewHsdqQuestionnaire';
import { hsdqQuestionOptions } from '../../../../../../../common/validation/customControls/somnology';
import { Step } from '../../../../../elements/atoms/step/Step';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';
import { PageIntro } from '../../../../../elements/organisms/pageIntro/PageIntro';
import { QuestionnaireRadioGroup } from '../../../../../elements/organisms/questionnaireRadioGroup/QuestionnaireRadioGroup';
import { StyledFormGroup } from '../../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function Step6(props: IQuestionnaireFormProps) {
    const questions: IHsdqQuestion[] = [
        {
            key: 'normalTime',
            label: 'Ik slaap slecht omdat het me niet lukt om een normale tijd in te slapen en ’s morgens op een normale tijd wakker te worden',
            number: 26,
        },
        {
            key: 'sleepBadlyDuringDay',
            label: 'Als ik ’s nachts wakker moet blijven, slaap ik overdag slecht',
            number: 27,
        },
        {
            key: 'moreThanTenHours',
            label: 'Ik slaap ’s nachts gewoonlijk meer dan 10 uur, heb moeite om ’s morgens wakker te worden en doe overdag ook dutjes',
            number: 28,
        },
        {
            key: 'sleepAttacks',
            label: 'Ik krijg overdag slaapaanvallen, die zó hevig zijn dat ik ze niet kan weerstaan',
            number: 29,
        },
        {
            key: 'timeVaries',
            label: 'Mijn tijd van inslapen wisselt sterk van dag tot dag',
            number: 30,
        },
    ];

    return (
        <>
            <PageIntro title="HSDQ: vragen deel 6/7" />

            <CustomContainer>
                {questions.map((question) => {
                    return (
                        <Stack key={question.key}>
                            <Step>{question.number}/32</Step>
                            <StyledFormGroup
                                hasErrors={props.errors.has(question.key)}
                                label={question.label}
                                layout="vertical"
                            >
                                <QuestionnaireRadioGroup
                                    {...props}
                                    customControlData={props.procedure.customControlData}
                                    customControlKey={question.key}
                                    questionnaireOptions={hsdqQuestionOptions}
                                />
                            </StyledFormGroup>
                        </Stack>
                    );
                })}

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        Verder
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
